<template>
  <role-create detail :edit="isEdit" />
</template>

<script>
import RoleCreate from './RoleCreate.vue';

export default {
  name: 'RoleDetail',
  components: {
    RoleCreate,
  },
  computed: {
    isEdit() {
      return parseInt(this.$route.query.type, 10) !== 2;
    },
  },
};
</script>
